var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HistoryBewertung',{attrs:{"ready":_vm.ready,"themen":_vm.themen,"zeitraume":_vm.zeitraume,"bewertungen":_vm.bewertungen,"data":_vm.data}})}
var staticRenderFns = []

export { render, staticRenderFns }